export const validateCEP = new RegExp('^[0-9]{5}-[0-9]{3}$');

export async function isValidCEP(cep: string): Promise<{
  valido: boolean;
  viaCepUsado: boolean;
}> {
  const formatedCep = cep.replace(/[^0-9]/g, '');

  try {
    const s4eResponse = await fetch(
      `${process.env.REACT_APP_URL_BASE}/api/redeatendimento/Endereco?token=${process.env.REACT_APP_TOKEN_S4E_V2}&cep=${formatedCep}`,
      { method: 'POST' },
    );

    const cepS4e = await s4eResponse.json();

    // ✅ Se o S4E retornou dados, está tudo certo
    if (cepS4e?.dados) {
      return { valido: true, viaCepUsado: false };
    }

    // 🔄 Se não, tenta o ViaCEP
    const viaCepResponse = await fetch(
      `${process.env.REACT_APP_VIACEP}${formatedCep}/json/`,
    );

    if (!viaCepResponse.ok) return { valido: false, viaCepUsado: false };

    const cepExiste = await viaCepResponse.json();

    if (cepExiste.erro) return { valido: false, viaCepUsado: false };

    return { valido: true, viaCepUsado: true };
  } catch (err) {
    console.error('Erro ao validar CEP:', err);
    return { valido: false, viaCepUsado: false };
  }
}
